var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"login__footer"},[_c('ul',_vm._l((_vm.$t('login.footerLinks')),function(link){return _c('router-link',{key:link,attrs:{"to":("/" + link),"tag":"li"}},[_c('a',[_vm._v(_vm._s(link))])])}),1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15bd85e0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/LoginFooter.vue
// module id = null
// module chunks = 